export const ParameterActionTypes = {
    ADD_PARAMETER_SALE: 'ADD_PARAMETER_SALE',
    ADD_PARAMETER_COMMISSION_STRUCTURE: 'ADD_PARAMETER_COMMISSION_STRUCTURE:',
    ADD_PARAMETER_PROJECT: 'ADD_PARAMETER_PROJECT',
    ADD_PARAMETER_PROJECT_AND_CS: 'ADD_PARAMETER_PROJECT_AND_CS',
    FETCH_PARAMETERS_SUCCESS: 'FETCH_PARAMETERS_SUCCESS',
}
